import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/919845201215?text=Hello%20Amrut%20Group";

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-8 right-8 z-50 flex items-center justify-center w-14 h-14 bg-charcoal text-ivory shadow-lg hover:bg-charcoal/90 transition-all duration-300 group"
      aria-label="Contact on WhatsApp"
    >
      <MessageCircle
        size={22}
        strokeWidth={1.5}
        className="transition-transform duration-300 group-hover:scale-110"
      />
    </a>
  );
}
